import {MaterialPattern} from "@generated"
import type {StateLabel} from "@labels"

export interface MaterialPatternLabel extends StateLabel<MaterialPattern> {
    pattern: MaterialPattern
    label: string
}

export const MaterialPatternLabels: Map<MaterialPattern, MaterialPatternLabel> = new Map<MaterialPattern, MaterialPatternLabel>([
    [MaterialPattern.SolidUniform, {pattern: MaterialPattern.SolidUniform, state: MaterialPattern.SolidUniform, label: "Solid / Uniform"}],
    [MaterialPattern.TiledRepetitive, {pattern: MaterialPattern.TiledRepetitive, state: MaterialPattern.TiledRepetitive, label: "Tiled / Repetitive"}],
    [MaterialPattern.OrganicRandom, {pattern: MaterialPattern.OrganicRandom, state: MaterialPattern.OrganicRandom, label: "Organic / Random"}],
    [MaterialPattern.Woven, {pattern: MaterialPattern.Woven, state: MaterialPattern.Woven, label: "Woven"}],
    [MaterialPattern.Other, {pattern: MaterialPattern.Other, state: MaterialPattern.Other, label: "Other"}],
])
